import { atom } from 'recoil';

export const usersAtom = atom({
  key: 'usersAtom', 
  default: {
    loading: false,
    item: null,
    items: [],
    currentUser: null,
    error: null
  },
});